import React, { useEffect, useState } from "react";
import "./LinkFbPage.css";
import { useDispatch, useSelector } from "react-redux";
import { fbActions } from "../../../store/fb-slice";
import UserFbPages from "./UserFbPages";
import { useNavigate } from "react-router-dom";
import { fetchHomepageProfile } from "../../../store/homepage-profile-slice";
import UNIVERSAL from "../../../config/config";

const LinkFbPage = ({setIsWhatsAppLinked}) => {
  const dispatch = useDispatch();
  const [selectPageModal, setSelectPageModal] = useState(false);
  const [selectPermissionModal, setPermissionModal] = useState(false);
  const [allPages, setAllPages] = useState([]);
  const [showFbPageModal, setShowFbPageModal] = useState(false);
  const fbDetail = useSelector((state) => state.fb.fbDetails);
  const selectedFbPage = useSelector((state) => state.fb.selectedFbPage);
  const app_fb_user_id = useSelector((state) => state.fb.app_fb_user_id);
  const user = useSelector((state) => state.user.user);

  const homePageProfile = useSelector((state) => state.homePageProfile.data);

  const navigate = useNavigate();

  function handleFbConnect() {
    FB.login(
      function (response) {
        if (response.authResponse) {
          FB.api(`/me/permissions`, "GET", {}, function (res) {
            const allPermissions = check_permissions(res.data);
            if (allPermissions) {
              get_account_pages(
                response.authResponse.userID,
                `/${response.authResponse.userID}/accounts?fields=id ,access_token, category, name, about, picture, cover, is_published, tasks, promotion_eligible,business`,
                []
              );

              FB.api(`/${response.authResponse.userID}?fields=name,id,picture,email`, function (res) {
                if (res) {
                  let data = { ...response.authResponse, ...res };
                  dispatch(fbActions.setFbDetails({ name: data.name, email: data.email, access_token: data.accessToken, is_long_lived_token: false, id: data.id }));
                  setShowFbPageModal(true);
                }
              });
              setSelectPageModal(true);
            } else {
              // SHOW PERMISSIONS NOT GRANTED
              // FB.logout();
              setPermissionModal(true);
            }
          });
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      {
        scope: "pages_read_engagement, email, public_profile, pages_show_list, business_management, pages_manage_metadata",
        auth_type: "rerequest",
      }
    );
  }

  const get_account_pages = (userID, url, pages) => {
    let tmp = pages;
    FB.api(url, (res) => {
      if (res.data.length !== 0) {
        tmp = [...pages, ...res.data];
        const new_url = `/${userID}/accounts?fields=id ,access_token, category, name, about, picture, cover, is_published, tasks, promotion_eligible,business&after=${res.paging.cursors.after}`;
        get_account_pages(userID, new_url, tmp);
      } else {
        setAllPages(tmp);
      }
    });
    return;
  };

  const check_permissions = (data) => {
    let count = 0;
    const permissions = ["pages_read_engagement", "email", "public_profile", "pages_show_list", "business_management", "pages_manage_metadata"];
    data.map((item) => {
      if (permissions.includes(item.permission) && item.status === "granted") {
        count = count + 1;
      }
    });
    return count === permissions.length ? true : false;
  };

  function handleCloseModal() {
    setShowFbPageModal(false);
  }

  useEffect(() => {
    if (fbDetail) {
      async function saveFacebookUser() {
        return fetch(UNIVERSAL.BASEURL_1 + "/bizv2/save_fb_user", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
          },
          body: JSON.stringify({
            business_id: String(user?.app_business_id),
            user: fbDetail,
            platform : "web"
          }),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson.data) {
              dispatch(fbActions.setFbUserId(responseJson.data.app_fb_user_id));
            } else {
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      saveFacebookUser();
    } else {
      return;
    }
  }, [fbDetail, dispatch]);

  useEffect(() => {
    if (app_fb_user_id && selectedFbPage) {
      async function claimFacebookPage() {
        return fetch(UNIVERSAL.BASEURL_1 + "/bizv2/claim_facebook_page", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
          },
          body: JSON.stringify({
            app_fb_user_id: app_fb_user_id.toString(),
            business_id: String(user?.app_business_id),
            is_claimable: true,
            page_data: selectedFbPage,
            version: 2,
          }),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson.success) {
              if (responseJson?.data?.has_whatsapp_business_number && responseJson?.data?.whatsapp_account_type?.toLowerCase()==="business")  {
                setIsWhatsAppLinked(true)
                console.log(responseJson?.data, "WHATSAPP LINKED")
              }else {
                setIsWhatsAppLinked(false)
                console.log(responseJson?.data, "WHATSAPP NOT LINKED")
              }
              dispatch(fetchHomepageProfile({ businessId: user?.app_business_id }));
              navigate("/create-campaign");
            } else {
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      claimFacebookPage();
    } else {
      return;
    }
  }, [selectedFbPage, app_fb_user_id]);

  return (
    <div class="createFBLinkMain">
      <div className="createFBHeader">
        <h2>Reach more people</h2>
        <p className="p_createFBHeader">Advertise your business with Click to WhatsApp Ads</p>
      </div>

      <div id="linkFb">
        {showFbPageModal && <UserFbPages allPages={allPages} closeModal={handleCloseModal} />}
        <div className="linkFbImg">
          <img className="linkFb-img" src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/add-fb-page.svg" alt="create-first-campaign-img" />
        </div>
        <div class="linkFb-info">
          <h2 className="linkFb-info-heading">
            {!homePageProfile?.fb_link && homePageProfile?.fb_user_token_valid === false ? "Link your facebook page" : "Facebook Session expired, Please Re-Authenticate Again"}
          </h2>
          <p className="linkFb-info-subHeading">{!homePageProfile?.fb_link && homePageProfile?.fb_user_token_valid === false ? "Please link in your Facebook page, start running your ads in it grow your business and get more customers" : "Please re-link in your Facebook page as session got expired, start running your ads in it grow your business and get more customers"}</p>
          <button className="linkFb-button" onClick={handleFbConnect}>
            <img src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/facebook.svg" alt="facebook-icon" /> Link in your facebook page
          </button>
        </div>
      </div>
    </div>
  );
};

export default LinkFbPage;
